import { render, staticRenderFns } from "./singleCoup.vue?vue&type=template&id=c4dd1998&scoped=true&"
import script from "./singleCoup.vue?vue&type=script&lang=ts&"
export * from "./singleCoup.vue?vue&type=script&lang=ts&"
import style0 from "./singleCoup.vue?vue&type=style&index=0&id=c4dd1998&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dd1998",
  null
  
)

export default component.exports